"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiAdapter = void 0;
var ApiAdapter = /** @class */ (function () {
    function ApiAdapter() {
    }
    return ApiAdapter;
}());
exports.ApiAdapter = ApiAdapter;
//# sourceMappingURL=ApiAdapter.js.map